<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h5>Scores</h5>
        <select ref="city" v-model="selected" class="form-control border-primary">
          <option v-for="city in cities" :value="city.key">{{city.name}}</option>
        </select>
        <div class="form-group">
          <label>Instagram</label>
          <input ref="instagram" class="form-control" value="0" type="number"/>
        </div>
        <div class="form-group">
          <label>Interactive Wall</label>
          <input ref="quiz" class="form-control" value="0" type="number"/>
        </div>

        <div class="form-group">
          <label>AR App</label>
          <input ref="testDrive" class="form-control" value="0" type="number"/>
        </div>
        <div layout="row top-left">
          <span v-if="saved" self="left" class="alert alert-success">OK...</span>
          <button class="btn btn-danger" self="right" @click="postScores()">Update</button>
          <!--<button class="btn btn-danger" self="right" @click="resetScores()">Reset Score</button>-->
        </div>

      </div>

    </div>

  </div>
</template>

<script>
  import Backend from '@/Backend';
  import EventBus from '@/EventBus';

  export default {
    name: "PostScore",
    data() {
      return {
        cities: [],
        selected: '',
        saved: false
      }
    },
    methods: {
      resetScores() {
        Backend.instance.resetScores(this.selected).then((e) => {
          EventBus.$emit('scoresupdated');
        })
          .catch((e) => {

          });
      },

      postScores() {

        const ok = confirm('Scores wirklich überschreiben?');
        if (!ok) return;

        const testdrive = this.$refs.testDrive.value;
        const quiz = this.$refs.quiz.value;
        const instagram = this.$refs.instagram.value;

        console.log(this.selected);

        Backend.instance.postScores(this.selected, instagram, quiz, testdrive).then((e) => {
          EventBus.$emit('scoresupdated');

          this.saved = true;
          clearTimeout(this.to);
          this.to = setTimeout(() => {
            this.saved = false;
          }, 1000);
        })
          .catch((e) => {

          });
      }
    },
    created() {
      Backend.instance.getCities()
        .then((data) => {
          this.cities = data;
          // this.cities.sort((a, b) => {
          //   if (a.name < b.name) return -1;
          //   if (a.name > b.name) return 1;
          //   return 0;
          // });
          this.selected = this.cities[0].key;
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
</script>

<style scoped>
  select {
    margin-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/PostScore.vue